
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round","transform":"translate(4 4)"}},[_c('circle',{attrs:{"cx":"6.349","cy":"6.349","r":"6.349"}}),_c('path',{attrs:{"d":"M11.019 11.087l4.527 4.528"}})]),_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    